var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "backup",
      on: {
        mouseup: function($event) {
          $event.stopPropagation()
          return _vm.onOutUp()
        }
      }
    },
    [
      _vm.backup_name === "楼盘筛选套餐和标签"
        ? _c("div", { staticClass: "labels" }, [
            _c("h2", { staticClass: "normal" }, [_vm._v("楼盘筛选套餐和标签")]),
            _vm._v(" "),
            _c("div", { staticClass: "normal" }, [
              _vm._v("\n      新建标签类别："),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newLabelType,
                    expression: "newLabelType"
                  }
                ],
                attrs: { type: "text", placeholder: "输入类别名称后回车" },
                domProps: { value: _vm.newLabelType },
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.addNewLabelType.apply(null, arguments)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newLabelType = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "type-box" },
              _vm._l(_vm.backup_data, function(type, index) {
                return _c(
                  "div",
                  {
                    key: "type" + index,
                    staticClass: "type",
                    style: {
                      "background-color": type.show ? "white" : "#cccccc"
                    },
                    on: {
                      mouseup: function($event) {
                        $event.stopPropagation()
                        return _vm.changeTypeOrder2(index)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "type-name" }, [
                      _c("div", [
                        _c(
                          "span",
                          {
                            on: {
                              mousedown: function($event) {
                                $event.stopPropagation()
                                return _vm.changeTypeOrder1(index)
                              }
                            }
                          },
                          [_vm._v("类别：")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: type.type,
                              expression: "type.type"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: type.type },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(type, "type", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.hideType(index)
                              }
                            }
                          },
                          [_vm._v("隐藏")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.delType(index)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: type.mode,
                                expression: "type.mode"
                              }
                            ],
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  type,
                                  "mode",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "group" } }, [
                              _vm._v("套餐")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "single" } }, [
                              _vm._v("单独")
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "normal" }, [
                        _vm._v("新建标签："),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: type.newLabelName,
                              expression: "type.newLabelName"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "输入标签名称后回车"
                          },
                          domProps: { value: type.newLabelName },
                          on: {
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.addNewLabel(index)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                type,
                                "newLabelName",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "label-box" },
                      _vm._l(type.labels, function(label, iindex) {
                        return _c(
                          "div",
                          {
                            key: "label" + iindex,
                            staticClass: "label",
                            style: {
                              "background-color": label.show
                                ? "skyblue"
                                : "grey"
                            },
                            on: {
                              mousedown: function($event) {
                                $event.stopPropagation()
                                return _vm.changeLabelOrder1(index, iindex)
                              },
                              mouseup: function($event) {
                                $event.stopPropagation()
                                return _vm.changeLabelOrder2(index, iindex)
                              },
                              click: function($event) {
                                label.show = !label.show
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "delLabel",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return type.labels.splice(iindex, 1)
                                  },
                                  mousedown: function($event) {
                                    $event.stopPropagation()
                                    return _vm.puts.apply(null, arguments)
                                  }
                                }
                              },
                              [_vm._v("删")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "hideLabel",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    type.labels[iindex].show = !type.labels[
                                      iindex
                                    ].show
                                  },
                                  mousedown: function($event) {
                                    $event.stopPropagation()
                                    return _vm.puts.apply(null, arguments)
                                  }
                                }
                              },
                              [_vm._v("隐")]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(label.name))]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(label.search_num))])
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              }),
              0
            )
          ])
        : _vm.backup_name === "非无需摇号的楼盘"
        ? _c(
            "div",
            [
              _c("h2", { staticClass: "normal" }, [_vm._v("非无需摇号的楼盘")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择",
                    multiple: true,
                    size: "mini",
                    filterable: true,
                    "default-first-option": ""
                  },
                  model: {
                    value: _vm.idList,
                    callback: function($$v) {
                      _vm.idList = $$v
                    },
                    expression: "idList"
                  }
                },
                _vm._l(_vm.realNameList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.real_estate_name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm.backup_name === "干货海报底图"
        ? _c("div", { staticClass: "other" }, [
            _c("h2", { staticClass: "normal" }, [_vm._v("干货海报底图")]),
            _vm._v(" "),
            _c("div", { staticClass: "normal" }, [
              _c("input", {
                attrs: { type: "file", id: "sunshine" },
                on: { change: _vm.chooseImage }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "imageBox" },
              _vm._l(_vm.images, function(img, index) {
                return _c("div", { key: index, staticClass: "imageItem" }, [
                  _c("div", { staticClass: "normal" }, [
                    _vm._v("名称："),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: img.title,
                          expression: "img.title"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: img.title },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(img, "title", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("img", { attrs: { src: img.img, preview: "1" } }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.delImage("images", index)
                        }
                      }
                    },
                    [_vm._v("删除")]
                  )
                ])
              }),
              0
            )
          ])
        : _vm.backup_name === "服务号领取干货回复"
        ? _c(
            "div",
            [
              _c("h2", { staticClass: "normal" }, [
                _vm._v("服务号领取干货回复")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "normal" },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.addReply } },
                    [_vm._v("添加")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.replyList, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticStyle: { "margin-top": "40px" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "normal",
                        staticStyle: { display: "inline-block" }
                      },
                      [
                        _vm._v("\n        回复的内容：\n        "),
                        _c("el-input", {
                          staticStyle: { "font-size": "20px" },
                          attrs: {
                            type: "textarea",
                            cols: "40",
                            rows: "5",
                            resize: "none"
                          },
                          model: {
                            value: item.word,
                            callback: function($$v) {
                              _vm.$set(item, "word", $$v)
                            },
                            expression: "item.word"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "normal" },
                      [
                        _vm._v("\n        命中关键字：\n        "),
                        _c("el-select", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            multiple: "",
                            "allow-create": "",
                            filterable: "",
                            "default-first-option": "",
                            placeholder: "命中的关键字",
                            size: "mini"
                          },
                          model: {
                            value: item.keys,
                            callback: function($$v) {
                              _vm.$set(item, "keys", $$v)
                            },
                            expression: "item.keys"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.setDefault(index)
                          }
                        }
                      },
                      [_vm._v(_vm._s(item.default ? "取消默认" : "设为默认"))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "info" },
                        on: {
                          click: function($event) {
                            return _vm.delReply(index)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm.backup_name === "关注小鸡选房自动回复"
        ? _c("div", { staticClass: "normal" }, [
            _c("h2", { staticClass: "normal" }, [
              _vm._v("关注小鸡选房自动回复")
            ]),
            _vm._v(" "),
            _vm.onReplyList.length > 0
              ? _c(
                  "div",
                  { staticClass: "normal" },
                  [
                    _c("div", [_vm._v("==========消息列表==========")]),
                    _vm._v(" "),
                    _vm._l(_vm.onReplyList, function(item, index) {
                      return _c("div", { key: index, staticClass: "normal" }, [
                        item.type === "text"
                          ? _c("div", [
                              _vm._v(
                                "\n          (文字消息)\n          " +
                                  _vm._s(item.words) +
                                  "\n          "
                              ),
                              _c(
                                "button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.delReplyMsg(index)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "mp"
                          ? _c(
                              "div",
                              [
                                _vm._v("\n          (小程序链接)\n          "),
                                _c("el-image", {
                                  staticStyle: {
                                    width: "200px",
                                    height: "200px"
                                  },
                                  attrs: {
                                    src: item.url,
                                    fit: "contain",
                                    "preview-src-list": [item.url]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.delReplyMsg(index)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "image"
                          ? _c(
                              "div",
                              [
                                _vm._v("\n          (图片消息)\n          "),
                                _c("el-image", {
                                  staticStyle: {
                                    width: "200px",
                                    height: "200px"
                                  },
                                  attrs: {
                                    src: item.url,
                                    fit: "contain",
                                    "preview-src-list": [item.url]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.delReplyMsg(index)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "normal" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.addReplyMsg("text")
                      }
                    }
                  },
                  [_vm._v("添加文字")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.addReplyMsg("mp")
                      }
                    }
                  },
                  [_vm._v("添加小程序")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.addReplyMsg("image")
                      }
                    }
                  },
                  [_vm._v("添加图片")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "normal" }, [
              _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  _c("el-input", {
                    staticStyle: { "font-size": "18px" },
                    attrs: {
                      type: "textarea",
                      placeholder: "文字消息",
                      cols: "40",
                      rows: "5",
                      resize: "none"
                    },
                    model: {
                      value: _vm.msgWords,
                      callback: function($$v) {
                        _vm.msgWords = $$v
                      },
                      expression: "msgWords"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "normal" },
              [
                _c("div", [_vm._v("==========图片素材==========")]),
                _vm._v(" "),
                _vm._l(_vm.materialList, function(image) {
                  return _c(
                    "div",
                    {
                      key: image.media_id,
                      staticStyle: {
                        display: "inline-block",
                        border: "black 1px solid",
                        position: "relative"
                      }
                    },
                    [
                      _c("el-image", {
                        staticStyle: { width: "200px", height: "200px" },
                        attrs: {
                          src: image.url,
                          fit: "contain",
                          "preview-src-list": [image.url]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          staticStyle: {
                            position: "absolute",
                            left: "10px",
                            top: "10px",
                            "z-index": "999",
                            "background-color": "#cccccc"
                          },
                          attrs: { label: image.media_id },
                          model: {
                            value: _vm.media_id,
                            callback: function($$v) {
                              _vm.media_id = $$v
                            },
                            expression: "media_id"
                          }
                        },
                        [_vm._v("选择")]
                      )
                    ],
                    1
                  )
                })
              ],
              2
            )
          ])
        : _vm.backup_id === "1ne188ej8pl"
        ? _c(
            "div",
            { staticClass: "normal" },
            [
              _vm._v("\n    排除的楼盘\n    "),
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "选择楼盘",
                    "default-first-option": "",
                    "remote-method": _vm.searchEstate,
                    remote: "",
                    multiple: ""
                  },
                  model: {
                    value: _vm.exEstates,
                    callback: function($$v) {
                      _vm.exEstates = $$v
                    },
                    expression: "exEstates"
                  }
                },
                _vm._l(_vm.matchEstates, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.real_estate_name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          )
        : _c("div", { staticClass: "other" }, [
            _c("h2", { staticClass: "normal" }, [_vm._v("杂七杂八")]),
            _vm._v(" "),
            _c("div", { staticClass: "normal" }, [
              _vm._v("名称："),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.backup_name,
                    expression: "backup_name"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.backup_name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.backup_name = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "normal" }, [
              _vm._v("数据："),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.backup_data,
                    expression: "backup_data"
                  }
                ],
                attrs: { cols: "50", rows: "10" },
                domProps: { value: _vm.backup_data },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.backup_data = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "normal" }, [
              _c("input", {
                attrs: { type: "file" },
                on: { change: _vm.chooseImage }
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _c("img", { attrs: { src: _vm.imgSrc, alt: "", preview: "6" } })
            ])
          ]),
      _vm._v(" "),
      _c("button", { staticClass: "up", on: { click: _vm.upToDb } }, [
        _vm._v("上传数据库")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6691ccf9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6691ccf9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/backup.vue
// module id = null
// module chunks = 